/* eslint-disable @typescript-eslint/ban-ts-comment */
import {AxiosResponse} from "axios";
import {Filter} from "@mm-products/java-multima-framework";
import {taxGuruAxios} from "../axios";
import {taxDocumentAttachmentUrls} from "../url";
import {TaxDocumentAttachmentResult} from "../models/TaxDocumentAttachmentResult";
import {TaxDocumentAttachmentDto} from "../models/TaxDocumentAttachmentDto";

export const listDocumentAttachments = (filter: Filter, toastId?: string): Promise<AxiosResponse<TaxDocumentAttachmentResult>> => {
    return taxGuruAxios.post(taxDocumentAttachmentUrls.filter, filter, {
        // @ts-ignore
        toastId,
    });
};

export const getDocumentAttachment = (
    id: string,
    toastId?: string,
    signal?: AbortSignal,
    noErrorToast?: boolean
): Promise<TaxDocumentAttachmentDto> => {
    return taxGuruAxios
        .get(taxDocumentAttachmentUrls.get(encodeURIComponent(id)), {
            // @ts-ignore
            toastId,
            signal,
            noErrorToast,
        })
        .then((res) => res.data);
};